module.exports = __webpack_public_path__ + "cancellara-dist/img/ticket-compliments.ad23ffb2.png";